import { useState } from 'react';
import { useSubmitElevationCertificateMutation } from '../services/api';
import { AddressSearchBar } from './general/AddressSearchBar';
import { Button } from './general/Button';
import { errorToast, successToast } from '../utils/toast';

export const CertificateIntake = () => {
  const [formData, setFormData] = useState({
    baseElevation: '',
    coordinates: '',
    firstFloorElevation: '',
    certDate: '',
    fileName: '',
    email: '',
  });

  const [resetAddress, setResetAddress] = useState(false);

  const [submitElevationCertificateInformation] = useSubmitElevationCertificateMutation();

  const handleChange = e => {
    const { name, value, type } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'number' ? Number(value) : value,
    });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setResetAddress(true);
    setFormData({
      baseElevation: '',
      coordinates: '',
      firstFloorElevation: '',
      certDate: '',
      fileName: '',
      email: '',
    });

    submitElevationCertificateInformation(formData)
      .unwrap()
      .then(_ => {
        successToast('Certificate submission successful!');
      })
      .catch(error => {
        console.error(error);
        errorToast('Certificate submission failed. Please try again later.');
      });
  };

  const handleAddressChange = ({ coordinates }) => {
    setFormData({ ...formData, coordinates });
  };

  return (
    <>
      <form onSubmit={handleSubmit} className="mx-8 mt-8 h-full min-h-screen space-y-4 p-4">
        <h1 className="mb-8 text-2xl">Elevation Certificate Information Intake</h1>
        <div className="w-80">
          <label className="block font-medium">Address:</label>
          <AddressSearchBar
            placeholder="Enter address"
            onAddressClickCb={handleAddressChange}
            resetTrigger={resetAddress}
            onResetComplete={() => setResetAddress(false)}
          />
        </div>
        <div>
          <label className="block font-medium">Base Flood Elevation:</label>
          <input
            type="number"
            name="baseElevation"
            value={formData.baseElevation}
            onChange={handleChange}
            required
            className="w-64 border p-2"
          />
        </div>
        <div>
          <label className="block font-medium">First Floor Elevation:</label>
          <input
            type="number"
            name="firstFloorElevation"
            value={formData.firstFloorElevation}
            onChange={handleChange}
            required
            className="w-64 border p-2"
          />
        </div>
        <div>
          <label className="block font-medium">Date of Elevation Certificate:</label>
          <input
            type="date"
            name="certDate"
            value={formData.certDate}
            onChange={handleChange}
            required
            className="w-64 border p-2"
          />
        </div>
        <div>
          <label className="block font-medium">Certification file name:</label>
          <input
            name="fileName"
            value={formData.fileName}
            onChange={handleChange}
            required
            className="w-64 border p-2"
          />
        </div>
        <div>
          <label className="block font-medium">Your email:</label>
          <input
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            className="mb-8 w-64 border p-2 "
          />
        </div>
        <Button type="submit" className="w-60 text-white">
          Submit
        </Button>
      </form>
    </>
  );
};
